<script>
import { __ } from '~/javascripts/lib/locale';

export default {
  props: {
    // Should be refactored to using `tax`-names instead of `vat`:
    // https://gitlab.com/gitlab-org/customers-gitlab-com/-/issues/7469
    vatCode: {
      required: false,
      type: String,
      default: '',
    },
    // Should be refactored to using `tax`-names instead of `vat`:
    // https://gitlab.com/gitlab-org/customers-gitlab-com/-/issues/7469
    showVatCode: {
      required: true,
      type: Boolean,
    },
    zuoraAccountName: {
      required: true,
      type: String,
    },
  },
  computed: {
    vatCodeText() {
      return this.vatCode || __(this.$options.i18n.notSet);
    },
  },
  i18n: {
    title: 'Company information',
    taxId: 'Tax ID',
    notSet: 'Not set',
  },
};
</script>
<template>
  <div>
    <h6 class="gl-text-gray-900">{{ __($options.i18n.title) }}</h6>
    <div data-testid="billing-account-company-name">{{ zuoraAccountName }}</div>
    <div v-if="showVatCode" data-testid="billing-account-tax-id">
      {{ __($options.i18n.taxId) }}: {{ vatCodeText }}
    </div>
  </div>
</template>
